export const SUMOTEST_CONVERSION_ENDPOINT = '/api/sumotest/convert/';
export const SUMOTEST_SHARE_METRIC = 'share';
